module.exports = __webpack_public_path__ + "static/media/pistol-poem.d5b3c86b.txt";